import { queryAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const pipedrive = defineConnector({
  identifier: "pipedrive",
  name: "Pipedrive",
  tagLine: "Sales CRM platform",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: () => "https://api\\.pipedrive\\.com/.*",
  auth: (app) => queryAuth([{ name: "api_token", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Get your Pipedrive API token",
      items: [
        {
          kind: "markdown",
          content:
            "In Pipedrive, go to **Settings > Personal preferences > API** to find your personal API token.",
        },
      ],
    },
    {
      title: "Enter your API token",
      items: [
        {
          kind: "input",
          label: "API token",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.pipedrive.com/v1/users/me",
  },
});
